import { VIRTUAL_CLASSROOM_TYPES } from '@didaskill/domain/virtual-classrooms/constants';

export enum LEARNING_RESOURCE_TYPE {
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  REPLAY = 'REPLAY',
  VIDEO = 'VIDEO',
}

export enum LEARNING_RESOURCE_VIEW {
  STUDENT = 'STUDENT',
  FULL = 'FULL',
}

export enum LEARNING_RESOURCE_REFERENCES_SCOPE {
  STRICT = 'STRICT',
  STUDENT_DISCOVERY = 'STUDENT_DISCOVERY',
}

export const LEARNING_RESOURCE_TAG = {
  ...VIRTUAL_CLASSROOM_TYPES,
} as const;

export enum LEARNING_RESOURCE_REFERENCE_TYPES {
  LESSON = 'LESSON',
  COURSE = 'COURSE',
  VIRTUAL_CLASSROOM = 'VIRTUAL_CLASSROOM',
}
export * from './model';
